import { createSelector } from '@ngrx/store';
import { authQuery as authTokenQuery } from '@cigna/shared/angular/auth-data-access';
import { AccessToken, JWT_NS } from './authstate.models';

const selectFromAccessNS = <TProp extends keyof AccessToken[typeof JWT_NS]>(
  prop: TProp,
) =>
  createSelector(
    authTokenQuery.getAuthData,
    (authData) =>
      authData?.accessTokenBody[JWT_NS] &&
      (authData.accessTokenBody as AccessToken)[JWT_NS][prop],
  );
const getUseremail = selectFromAccessNS('email');
const getUserfirstName = selectFromAccessNS('firstName');
const getUserlastName = selectFromAccessNS('lastName');

const selectFromAccess = createSelector(
  authTokenQuery.getAuthData,
  (authData) =>
    authData !== undefined ? (authData.accessToken as string) : authData,
);

const getAccessToken = createSelector(selectFromAccess, (accessToken) =>
  accessToken ? accessToken : undefined,
);

export const authQuery = {
  getUseremail,
  getUserfirstName,
  getUserlastName,
  getAccessToken,
};
